// @ts-ignore
import { Wechat } from '@tencent/qcloud-account-lib';
import { message, Spin } from 'antd';
import { isEmpty } from 'lodash-es';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getParamFromUrl, toSearchStr } from '@/infrastructure/history';
import { useAuthContext } from '@/presentation/hooks';
import { REDIRECT_URL } from '@/presentation/pages/login/constant';
import { LoginType } from '@/presentation/pages/login/types';
import { useLoginContext } from '@/presentation/pages/login/use-login';
import { authService } from '@/service/auth';
import { RegisterType, tencentCloudService } from '@/service/tencent-cloud';
import styles from './index.module.scss';

export const TencentCloudLogin = () => {
  const history = useHistory();
  const { loading, setLoading } = useLoginContext();
  const redirectURL = encodeURIComponent(getParamFromUrl('url'));
  const wechatRef = useRef<any>(new Wechat({
    imgSize: 188 | 180, // 二维码大小
    redirectUrl: REDIRECT_URL,
  }));
  const [qrcode] = useState(wechatRef.current?.getAuthUrl());
  const { onLoginSuccess } = useAuthContext();

  useEffect(() => {
    wechatRef.current.on('recieveAuthCode', async (authInfo: {authCode: string}) => {
      setLoading(true);
      const { authCode } = authInfo;
      const { token, accountList } = await tencentCloudService.preloginForWechat(authCode);

      if (!token) {
        // todo
        return;
      }

      if (isEmpty(accountList)) {
        // 注册流程
        history.push({
          pathname: '/register',
          search: toSearchStr({
            token: token.key as string,
            registerType: RegisterType.Wechat,
            url: redirectURL,
          }),
        });
        return;
      }

      if (accountList.length > 1) {
        // 账号切换流程
        history.push({
          pathname: '/select-account',
          state: {
            accountList,
            token,
          },
          search: toSearchStr({
            url: redirectURL,
          }),
        });
        return;
      }

      const loginRes = await authService.login(LoginType.TencentCloud, {
        saasToken: token.key,
        uin: `${token.uin}` as string,
        ownerUin: `${token.ownerUin}` as string,
      });

      if (loginRes) {
        onLoginSuccess(LoginType.TencentCloud, loginRes?.userInfo, {
          ...token,
          buglyToken: loginRes?.buglyToken,
          saasToken: token.key,
        });
      } else {
        message.error('登录失败，请稍后再试！');
      }
    });
    return () => {
      wechatRef.current.destory();
    };
  }, []);

  return (
    <div className={styles.tencentCloudForm}>
      <Spin spinning={loading}>
        <div className={styles.qrcode}>
          <iframe
            frameBorder={'0'}
            scrolling={'no'}
            width={186}
            height={186}
            src={qrcode}
            onLoad={() => {
              setLoading(false);
            }}
            onError={() => {
              setLoading(false);
            }}
          />
        </div>
      </Spin>
    </div>
  );
};
